import { render, staticRenderFns } from "./pointer.vue?vue&type=template&id=90872432"
import script from "./pointer.vue?vue&type=script&lang=js"
export * from "./pointer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports